import { lazy } from 'react';
function lazyWithPreload(factory) {
  const Component = /*#__PURE__*/lazy(factory);
  Component.preload = factory;
  return Component;
}
export const agentHubRegistryEntry = {
  namespace: 'AGENT_HUB',
  components: {
    PLAN_REVIEW: lazyWithPreload(() => import( /* webpackChunkName: "agent-hub-components" */'./PlanReviewCard')),
    CREATED_AGENT: lazyWithPreload(() => import( /* webpackChunkName: "agent-hub-components" */'./CreatedAgentCard'))
  }
};